import { render } from "./view.vue?vue&type=template&id=6f742520&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=6f742520&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f742520"

export default script